import { IMtdEmReportsItem } from 'redux/reducers/hmrc/types';
import { TTableStructure, ETableStructureAlign, ETableStructureType } from 'ui/EasTable/types';
import { DATES_ID, DATES } from '../../../services/constants/dates-constants';

export const easReportStructure: TTableStructure<keyof IMtdEmReportsItem>[] = [
	{
		name: 'ID',
		selector: 'id' as keyof IMtdEmReportsItem,
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.LINK,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'EM Full Name',
		selector: 'emFullName' as keyof IMtdEmReportsItem,
		show: false,
		searchable: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'VAT Registration Number',
		selector: 'vatRegistrationNumber' as keyof IMtdEmReportsItem,
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Report Period',
		selector: 'reportPeriod' as keyof IMtdEmReportsItem,
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.DATE_PERIOD,
		align: ETableStructureAlign.CENTER,
		colSpan: 1,
	},
	{
		name: 'Due Date',
		selector: 'reportDueDate' as keyof IMtdEmReportsItem,
		show: true,
		sortable: true,
		filterable: true,
		filter: [
			[DATES_ID.NEXT_YEAR, DATES.NEXT_YEAR],
			[DATES_ID.NEXT_QUARTER, DATES.NEXT_QUARTER],
			[DATES_ID.NEXT_MONTH, DATES.NEXT_MONTH],
			[DATES_ID.NEXT_30_DAYS, DATES.NEXT_30_DAYS],
			[DATES_ID.NEXT_7_DAYS, DATES.NEXT_7_DAYS],
			[DATES_ID.TOMORROW, DATES.TOMORROW],
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
			[DATES_ID.CUSTOM_RANGE, DATES.CUSTOM_RANGE],
		],

		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
		colSpan: 1,
	},
	{
		name: 'EAS Calculated\n VAT Due',
		selector: 'calculatedNetVatDue' as keyof IMtdEmReportsItem,
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		currency: () => 'GBP',
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Calculated\nTotal VAT Due',
		selector: 'calculatedTotalVatDue' as keyof IMtdEmReportsItem,
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		currency: () => 'GBP',
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},

	{
		name: 'Reported\nVAT Due Sales',
		selector: 'reportedVatDueSales' as keyof IMtdEmReportsItem,
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		currency: () => 'GBP',
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Calculated\nVAT Due Acquisitions',
		selector: 'calculatedVatDueAcquisitions' as keyof IMtdEmReportsItem,
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		currency: () => 'GBP',
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Reported\nVAT Due Acquisitions',
		selector: 'reportedVatDueAcquisitions' as keyof IMtdEmReportsItem,
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		currency: () => 'GBP',
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Reported\nTotal VAT Due',
		selector: 'reportedTotalVatDue' as keyof IMtdEmReportsItem,
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		currency: () => 'GBP',
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Calculated\nVAT Reclaimed',
		selector: 'calculatedVatReclaimedCurrPeriod' as keyof IMtdEmReportsItem,
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		currency: () => 'GBP',
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Reported\nVAT Reclaimed',
		selector: 'reportedVatReclaimedCurrPeriod' as keyof IMtdEmReportsItem,
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,

		currency: () => 'GBP',
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Reported\nNet VAT Due',
		selector: 'reportedNetVatDue' as keyof IMtdEmReportsItem,
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,

		currency: () => 'GBP',
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Calculated\nTotal Sales Ex VAT',
		selector: 'calculatedTotalValueSalesExVAT' as keyof IMtdEmReportsItem,
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		currency: () => 'GBP',
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Reported\nTotal Sales Ex VAT',
		selector: 'reportedTotalValueSalesExVAT' as keyof IMtdEmReportsItem,
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		currency: () => 'GBP',
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Calculated\nTotal Purchases Ex VAT',
		selector: 'calculatedTotalValuePurchasesExVAT' as keyof IMtdEmReportsItem,
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		currency: () => 'GBP',
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Reported\nTotal Purchases Ex VAT',
		selector: 'reportedTotalValuePurchasesExVAT' as keyof IMtdEmReportsItem,
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		currency: () => 'GBP',
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Calculated\nTotal Goods Supplied Ex VAT',
		selector: 'calculatedTotalValueGoodsSuppliedExVAT' as keyof IMtdEmReportsItem,
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		currency: () => 'GBP',
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Reported\nTotal Goods Supplied Ex VAT',
		selector: 'reportedTotalValueGoodsSuppliedExVAT' as keyof IMtdEmReportsItem,
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		currency: () => 'GBP',
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Calculated\nTotal Acquisitions Ex VAT',
		selector: 'calculatedTotalAcquisitionsExVAT' as keyof IMtdEmReportsItem,
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		currency: () => 'GBP',
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Reported\nTotal Acquisitions Ex VAT',
		selector: 'reportedTotalAcquisitionsExVAT' as keyof IMtdEmReportsItem,
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		currency: () => 'GBP',
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Reporting Issues',
		selector: 'reportingIssues' as keyof IMtdEmReportsItem,
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		filter: [
			['Lack of EAS reports', 'Lack of EAS reports'],
			['Incomplete period', 'Incomplete period'],
		],
		colors: [
			['Lack of EAS reports', 'error.light'],
			['Incomplete period', 'warning.light'],
		],
		colSpan: 1,
	},
	{
		name: 'Report Status',
		selector: 'reportStatus' as keyof IMtdEmReportsItem,
		show: true,
		sortable: true,
		filterable: true,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		filter: [
			['pending', 'Pending'],
			['sent', 'Sent'],
		],
		colors: [
			['pending', 'warning.light'],
			['sent', 'success.light'],
		],
		colSpan: 1,
	},
	{
		name: 'Reported At',
		selector: 'reportedAt' as keyof IMtdEmReportsItem,
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
		colSpan: 1,
	},
	{
		name: 'Manual Report',
		selector: 'isManual' as keyof IMtdEmReportsItem,
		show: true,
		sortable: true,
		filterable: true,
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.CENTER,
		colSpan: 1,
	},
	{
		name: 'Comments',
		selector: 'comments' as keyof IMtdEmReportsItem,
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.COMMENTS,
		align: ETableStructureAlign.LEFT,
		colSpan: 2,
	},
	{
		name: 'Author',
		selector: 'author' as keyof IMtdEmReportsItem,
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
];

//"duration": "[\"2025-12-01 00:00:00+00\",\"2026-01-01 00:00:00+00\")",

// "duration": "(\"2025-09-23 11:32:56.879976+00\",\"2026-02-01 00:00:00+00\")"
